import { render, staticRenderFns } from "./Certificados.vue?vue&type=template&id=7f6080e5"
import script from "./Certificados.vue?vue&type=script&lang=js"
export * from "./Certificados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f6080e5')) {
      api.createRecord('7f6080e5', component.options)
    } else {
      api.reload('7f6080e5', component.options)
    }
    module.hot.accept("./Certificados.vue?vue&type=template&id=7f6080e5", function () {
      api.rerender('7f6080e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/certificados/Certificados.vue"
export default component.exports